import type { OperationVariables, QueryOptions } from "@apollo/client/core";
import type { ListParams } from "../../../core/schema/ListParams.js";
import type { GraphQLClient } from "../../../core/utils/aws/appsync/GraphQLClient.js";
import type { ListResponse } from "../../../core/utils/aws/dynamodb/ListResponse.js";
import { deeplyConvertNullToUndefined } from "../../../core/utils/deeplyConvertNullToUndefined.js";

export async function requestAll<Item, Variables extends OperationVariables & ListParams>(
	graphQL: GraphQLClient,
	options: QueryOptions<Variables, Item>,
	transform?: (item: Item) => Item | Promise<Item>,
): Promise<Item[]> {
	async function queryAllItems(): Promise<Item[]> {
		const items: Item[] = [];
		let nextToken: string | undefined;
		do {
			const response = await graphQL.query<ListResponse<Item>, Variables>({
				...options,
				// @ts-expect-error For some reason nextToken is causing a type error
				variables: {
					...options.variables,
					nextToken,
				},
			});
			nextToken = response?.nextToken;
			items.push(...(response?.items ?? []));
		} while (nextToken);
		return (transform ? await Promise.all(items.map(transform)) : items).map(deeplyConvertNullToUndefined);
	}

	return await queryAllItems();
}
